// ===== [VERY TOP] First-paint hide control (JS only) =====
(function preHideCurrencyBtnEarly() {
  try {
    var KEY = "crc_currency_hide_until_final"
    var path = String(window.location.pathname || "").toLowerCase()

    var isSystemPath =
      path.indexOf("/checkout") === 0 ||
      path.indexOf("/account") === 0 ||
      path.indexOf("/apps") === 0 ||
      path.indexOf("/admin") === 0 ||
      path.indexOf("/cart") === 0 ||
      path.indexOf("/orders") === 0

    var firstSeg = (String(window.location.pathname || "").split("/").filter(Boolean)[0] || "")
    var hasUrlLocalePrefix = /^[a-z]{2}[-_][a-z]{2}$/i.test(firstSeg)

    var hasPopupCrcCookie = String(document.cookie || "").indexOf("popupCrc=") > -1

    var hasLastSelection = false
    try {
      hasLastSelection = !!localStorage.getItem("crc_last_selection_v1")
    } catch (e) {}

    var shouldHideEarly =
      sessionStorage.getItem(KEY) === "1" ||
      (!isSystemPath && !hasUrlLocalePrefix && (hasPopupCrcCookie || hasLastSelection))

    if (!shouldHideEarly) return

    try {
      sessionStorage.setItem(KEY, "1")
    } catch (e) {}

    document.querySelectorAll(".currency-btn").forEach(function (el) {
      el.classList.remove("is-ready")
      el.style.display = "none"
      el.setAttribute("data-flag-ready", "false")
    })
  } catch (e) {}
})()

let availableCountries = []
let detectedCountryISO = ""

const storeName = "lewkinbt.myshopify.com"
const accessToken = "c48fd21bcee9932e8572b19d87a4973d"

const CRC_LS_KEY = "crc_last_selection_v1"
const CRC_CURRENCY_HIDE_KEY = "crc_currency_hide_until_final"

let crcCurrencyBtnObserver = null
let crcLocalizationSubmitInFlight = false

function setCurrencyBtnReadyState(isReady) {
  try {
    document.querySelectorAll(".currency-btn").forEach((el) => {
      if (isReady) {
        el.classList.add("is-ready")
        el.style.display = "block"
      } else {
        el.classList.remove("is-ready")
        el.style.display = "none"
        el.setAttribute("data-flag-ready", "false")
      }
    })
  } catch (e) {}
}


function getFlagEmoji(countryCode) {
  return String(countryCode || "")
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt()))
}


function renderFlagEmoji(flagWrap, code) {
  flagWrap.textContent = getFlagEmoji(code)

  if (typeof twemoji !== "undefined" && twemoji?.parse) {
    twemoji.parse(flagWrap, {
      folder: "svg",
      ext: ".svg",
    })
  }
}

function setCurrencyFlag(isoCode) {
  if (!isoCode) return

  const upperCode = normalizeCountryCode(isoCode)

  document.querySelectorAll(".currency-btn").forEach((btn) => {
    const flagWrap = btn.querySelector(".iconflag")
    if (!flagWrap) return

    const emoji = getFlagEmoji(upperCode)

    // 🔥 이미 같은 flag면 덮어쓰기 금지
    if (flagWrap.textContent.trim() === emoji && btn.getAttribute("data-flag-ready") === "true") {
      return
    }

    // 👉 emoji 렌더
    flagWrap.textContent = emoji

    if (typeof twemoji !== "undefined" && twemoji?.parse) {
      twemoji.parse(flagWrap, {
        folder: "svg",
        ext: ".svg",
      })
    }

    btn.setAttribute("data-flag", upperCode.toLowerCase())
    btn.style.display = "block"
    btn.classList.add("is-ready")
    btn.setAttribute("data-flag-ready", "true")
  })
}

function getFinalCountryForFlag() {
  try {
    const fromInput = normalizeCountryCode(document.getElementById("country_code")?.value || "")
    if (fromInput) return fromInput

    const prefix = getUrlLocalePrefix()
    if (prefix) {
      const parsed = parsePrefixToCountryAndLang(prefix)
      const fromPrefix = normalizeCountryCode(parsed.country || "")
      if (fromPrefix) return fromPrefix
    }

    const cookie = crcGetParsedPopupCookie()
    const fromCookie = normalizeCountryCode(cookie?.country_code || "")
    if (fromCookie) return fromCookie

    const last = crcLoadLastSelection()
    const fromLast = normalizeCountryCode(last?.country_code || "")
    if (fromLast) return fromLast
  } catch (e) {}

  return ""
}

function syncCurrencyFlagToCurrentState() {
  const finalCountry = getFinalCountryForFlag()
  if (!finalCountry) return false

  setCurrencyFlag(finalCountry)
  return true
}

function isRedirectPendingState() {
  try {
    return sessionStorage.getItem(CRC_CURRENCY_HIDE_KEY) === "1"
  } catch (e) {
    return false
  }
}

function hideCurrencyBtnUntilFinalLoad() {
  try {
    sessionStorage.setItem(CRC_CURRENCY_HIDE_KEY, "1")
  } catch (e) {}
  setCurrencyBtnReadyState(false)
}

function showCurrencyBtnWhenReady() {
  try {
    sessionStorage.removeItem(CRC_CURRENCY_HIDE_KEY)
  } catch (e) {}

  stopCurrencyBtnHideObserver()

  if (syncCurrencyFlagToCurrentState()) return

  setCurrencyBtnReadyState(true)
}

function applyCurrencyBtnVisibilityFromSession() {
  try {
    const shouldHide = sessionStorage.getItem(CRC_CURRENCY_HIDE_KEY) === "1"
    setCurrencyBtnReadyState(!shouldHide)
  } catch (e) {}
}

function startCurrencyBtnHideObserver() {
  try {
    if (crcCurrencyBtnObserver) return

    crcCurrencyBtnObserver = new MutationObserver(() => {
      try {
        const shouldHide = sessionStorage.getItem(CRC_CURRENCY_HIDE_KEY) === "1"
        if (shouldHide) {
          document.querySelectorAll(".currency-btn").forEach((el) => {
            el.classList.remove("is-ready")
            el.style.display = "none"
            el.setAttribute("data-flag-ready", "false")
          })
        }
      } catch (e) {}
    })

    crcCurrencyBtnObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    })
  } catch (e) {}
}

function stopCurrencyBtnHideObserver() {
  try {
    crcCurrencyBtnObserver?.disconnect()
    crcCurrencyBtnObserver = null
  } catch (e) {}
}

;(function preApplyCurrencyState() {
  try {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", applyCurrencyBtnVisibilityFromSession, { once: true })
    } else {
      applyCurrencyBtnVisibilityFromSession()
    }
  } catch (e) {}
})()

function crcSaveLastSelection(countryCode, languageIso) {
  try {
    const c = normalizeCountryCode(countryCode || "US")
    const l = normalizeLocaleForShopify(languageIso || "en")
    localStorage.setItem(CRC_LS_KEY, JSON.stringify({ country_code: c, language_code: l, ts: Date.now() }))
  } catch (e) {}
}

function crcLoadLastSelection() {
  try {
    const raw = localStorage.getItem(CRC_LS_KEY)
    if (!raw) return null
    const obj = JSON.parse(raw)
    const c = normalizeCountryCode(obj?.country_code || "")
    const l = normalizeLocaleForShopify(obj?.language_code || "en")
    if (!c) return null
    return { country_code: c, language_code: l, ts: Number(obj?.ts || 0) }
  } catch (e) {
    return null
  }
}

function convertIsoCode(isoCode) {
  return String(isoCode || "").replace("_", "-")
}

function normalizeCountryCode(v) {
  return String(v || "").trim().toUpperCase()
}

function normalizeLocaleForShopify(iso) {
  const raw = convertIsoCode(String(iso || "en")).toLowerCase()
  return raw.split("-")[0].split("_")[0] || "en"
}

function ensureHiddenInput(form, name, value) {
  let input = form.querySelector(`input[name="${name}"]`)
  if (!input) {
    input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    form.appendChild(input)
  }
  input.value = value
}

function getUrlLocalePrefix() {
  const seg = String(window.location.pathname || "").split("/").filter(Boolean)[0] || ""
  if (/^[a-z]{2}[-_][a-z]{2}$/i.test(seg)) return convertIsoCode(seg)
  return ""
}

function parsePrefixToCountryAndLang(prefix) {
  const p = convertIsoCode(prefix || "")
  const parts = p.split("-")
  const lang = normalizeLocaleForShopify(parts[0] || "en")
  const country = normalizeCountryCode(parts[1] || "")
  return { lang, country }
}

function isShopifySystemPath(pathname) {
  const p = String(pathname || "").toLowerCase()
  return (
    p.startsWith("/checkout") ||
    p.startsWith("/account") ||
    p.startsWith("/apps") ||
    p.startsWith("/admin") ||
    p.startsWith("/cart") ||
    p.startsWith("/orders")
  )
}

function getCookieDomainCandidates() {
  const host = String(window.location.hostname || "").toLowerCase()
  const noWww = host.replace(/^www\./, "")
  const parts = noWww.split(".").filter(Boolean)

  if (parts.length < 2) return [""]

  const sld3 = new Set(["co.kr", "com.au", "co.uk", "org.uk", "ac.uk", "co.jp", "co.nz", "com.br", "com.mx"])

  const last2 = parts.slice(-2).join(".")
  const last3 = parts.slice(-3).join(".")
  const root = sld3.has(last2) ? last3 : last2

  const candidates = []
  candidates.push("." + noWww)
  if ("." + noWww !== "." + root) candidates.push("." + root)
  return candidates
}

function crcDeleteCookie(name, domain) {
  const secure = window.location.protocol === "https:" ? "; Secure" : ""
  const base = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax${secure}`
  if (domain) {
    document.cookie = `${base}; domain=${domain}`
  } else {
    document.cookie = base
  }
}

function crcSetCookie(name, value, days) {
  crcDeleteCookie(name)
  const domains = getCookieDomainCandidates()
  domains.forEach((d) => d && crcDeleteCookie(name, d))

  const date = new Date()
  date.setTime(date.getTime() + Number(days || 30) * 24 * 60 * 60 * 1000)

  const v = encodeURIComponent(String(value ?? ""))
  const expires = date.toUTCString()
  const secure = window.location.protocol === "https:" ? "; Secure" : ""

  const domainToUse = (domains || []).filter(Boolean).slice(-1)[0] || ""

  if (domainToUse) {
    document.cookie = `${name}=${v}; expires=${expires}; path=/; domain=${domainToUse}; SameSite=Lax${secure}`
  } else {
    document.cookie = `${name}=${v}; expires=${expires}; path=/; SameSite=Lax${secure}`
  }
}

function crcGetCookie(name) {
  const all = String(document.cookie || "")
    .split(";")
    .map((s) => s.trim())
    .filter((s) => s.startsWith(name + "="))
    .map((s) => decodeURIComponent(s.substring((name + "=").length)))

  if (!all.length) return ""

  let best = all[all.length - 1]
  let bestTs = -1

  for (const v of all) {
    try {
      const obj = JSON.parse(v)
      const ts = Number(obj?.ts || 0)
      if (ts > bestTs) {
        bestTs = ts
        best = v
      }
    } catch (e) {}
  }

  return best
}

function crcGetParsedPopupCookie() {
  try {
    const raw = crcGetCookie("popupCrc")
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

function setSessionLockWithTTL(key, value, ttlMs) {
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        value: String(value || ""),
        exp: Date.now() + Number(ttlMs || 3000),
      })
    )
  } catch (e) {}
}

function getSessionLockWithTTL(key) {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return ""
    const obj = JSON.parse(raw)
    const exp = Number(obj?.exp || 0)
    if (!exp || Date.now() > exp) {
      sessionStorage.removeItem(key)
      return ""
    }
    return String(obj?.value || "")
  } catch (e) {
    try {
      return String(sessionStorage.getItem(key) || "")
    } catch (e2) {
      return ""
    }
  }
}

function setSelectionCookie(countryCode, languageIso) {
  const c = normalizeCountryCode(countryCode || "US")
  const l = normalizeLocaleForShopify(languageIso || "en")

  const cookieValue = JSON.stringify({
    hidden: true,
    country_code: c,
    language_code: l,
    ts: Date.now(),
  })

  crcSetCookie("popupCrc", cookieValue, 30)
  crcSaveLastSelection(c, l)
}

function submitToLocalization(countryCode, languageIso) {
  if (crcLocalizationSubmitInFlight) return false
  crcLocalizationSubmitInFlight = true

  try {
    sessionStorage.setItem(CRC_CURRENCY_HIDE_KEY, "1")
  } catch (e) {}
  setCurrencyBtnReadyState(false)

  const form = document.getElementById("localization_form")
  if (!form) {
    crcLocalizationSubmitInFlight = false
    return false
  }

  const c = normalizeCountryCode(countryCode || "US")
  const l = normalizeLocaleForShopify(languageIso || "en")

  const countryInput = document.getElementById("country_code")
  const languageInput = document.getElementById("language_code")
  if (countryInput) countryInput.value = c
  if (languageInput) languageInput.value = l

  ensureHiddenInput(form, "country_code", c)
  ensureHiddenInput(form, "locale_code", l)
  ensureHiddenInput(form, "language_code", l)

  form.submit()
  return true
}

function handleLocalizationSubmission(cookieName) {
  const cookieValue = crcGetCookie(cookieName)
  if (!cookieValue) return false

  const form = document.getElementById("localization_form")
  const countryInput = document.getElementById("country_code")
  const languageInput = document.getElementById("language_code")
  if (!form || !countryInput || !languageInput) return false

  let parsedCookie = null
  try {
    parsedCookie = JSON.parse(cookieValue)
  } catch (e) {
    return false
  }

  const cookieCountry = normalizeCountryCode(parsedCookie?.country_code || "")
  const cookieLocale = normalizeLocaleForShopify(parsedCookie?.language_code || "en")

  const renderedCountry = normalizeCountryCode(countryInput.value || "")
  const renderedLocale = normalizeLocaleForShopify(languageInput.value || document.documentElement.lang || "en")

  if (!cookieCountry) return false

  const lockKey = "crc_submit_lock"
  const desired = `${cookieCountry}|${cookieLocale}`

  if (cookieCountry === renderedCountry && cookieLocale === renderedLocale) {
    try {
      sessionStorage.removeItem(lockKey)
    } catch (e) {}
    return false
  }

  const locked = getSessionLockWithTTL(lockKey)
  if (locked === desired) return false

  setSessionLockWithTTL(lockKey, desired, 3000)

  try {
    sessionStorage.setItem(CRC_CURRENCY_HIDE_KEY, "1")
  } catch (e) {}
  setCurrencyBtnReadyState(false)

  return submitToLocalization(cookieCountry, cookieLocale)
}

async function crcCallback() {
  const query = `
    {
      localization {
        availableCountries {
          isoCode
          name
          market { handle id }
          currency { isoCode symbol }
          availableLanguages { isoCode name }
        }
      }
    }
  `

  try {
    const response = await fetch(`https://${storeName}/api/2024-10/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
      },
      body: JSON.stringify({ query }),
    })

    if (!response.ok) throw new Error("Network response was not ok")

    const result = await response.json()
    if (result.errors) {
      console.error("GraphQL Errors:", result.errors)
      showCurrencyBtnWhenReady()
      return
    }

    availableCountries = result?.data?.localization?.availableCountries || []

    const didRedirect = await autoRedirectByIP(availableCountries)
    if (didRedirect) return

    renderAllCountriesUI(availableCountries)
    shx(availableCountries)

    const crcPopupBg = document.querySelector(".crc-popup-bg")
    if (crcPopupBg) crcPopupBg.classList.remove("init")

    showCurrencyBtnWhenReady()
  } catch (error) {
    console.error("Fetch Error:", error)
    showCurrencyBtnWhenReady()
  }
}

async function getIpCountryISO() {
  try {
    const response = await fetch("https://qa21cjkebi.execute-api.ap-northeast-2.amazonaws.com/test/")
    const data = await response.json()
    const iso = String(data.country || "").trim().toUpperCase()
    return iso || null
  } catch (e) {
    return null
  }
}

function pickDefaultLanguageIso(availableLanguages) {
  const arr = Array.isArray(availableLanguages) ? availableLanguages : []
  if (!arr.length) return "en"
  return arr[0]?.isoCode || "en"
}

async function autoRedirectByIP(countries) {
  if (isShopifySystemPath(window.location.pathname)) return false

  const urlPrefix = getUrlLocalePrefix()
  if (urlPrefix) return false

  const last = crcLoadLastSelection()
  if (last?.country_code) return false

  const cookie = crcGetCookie("popupCrc")
  if (cookie) return false

  const key = "crc_auto_redirect_done"
  if (sessionStorage.getItem(key) === "1") return false

  const ipISO = await getIpCountryISO()

  let target = null
  if (ipISO) {
    target = (countries || []).find((c) => normalizeCountryCode(c?.isoCode) === normalizeCountryCode(ipISO)) || null
  }
  if (!target) {
    target = (countries || []).find((c) => normalizeCountryCode(c?.isoCode) === "US") || null
  }

  const nextCountry = normalizeCountryCode(target?.isoCode || "US")
  const nextLangIso = pickDefaultLanguageIso(target?.availableLanguages)
  const nextLocale = normalizeLocaleForShopify(nextLangIso)

  const currentCountry = normalizeCountryCode(document.getElementById("country_code")?.value || "")
  const currentLocale = normalizeLocaleForShopify(
    document.getElementById("language_code")?.value || document.documentElement.lang || "en"
  )

  if (currentCountry === nextCountry && currentLocale === nextLocale) return false

  sessionStorage.setItem(key, "1")
  setSelectionCookie(nextCountry, nextLocale)

  try {
    sessionStorage.setItem(CRC_CURRENCY_HIDE_KEY, "1")
  } catch (e) {}
  setCurrencyBtnReadyState(false)

  return submitToLocalization(nextCountry, nextLocale)
}

const defaultCountries = [
  { isoCode: "Loading", name: "Loading", availableLanguages: [{ isoCode: "Loading", name: "Loading" }] },
]

function popupInitSetup() {
  const countrySelect = document.getElementById("popup-country-select")
  const langSelect = document.getElementById("popup-lang-select")
  if (!countrySelect || !langSelect) return

  defaultCountries.forEach((country) => {
    countrySelect.add(new Option(country.name, country.isoCode))
    country.availableLanguages.forEach((language) => {
      langSelect.add(new Option(language.name, language.isoCode))
    })
  })
}

function renderAllCountriesUI(countries) {
  const searchHistoryDiv = document.querySelector(".search-history")
  if (!searchHistoryDiv) return

  searchHistoryDiv.innerHTML = ""
  ;(countries || []).sort((a, b) => a.name.localeCompare(b.name, "ko"))

  ;(countries || []).forEach((country) => {
    ;(country.availableLanguages || []).forEach((language) => {
      const resultDiv = document.createElement("div")
      const countryParagraph = document.createElement("p")
      const languageParagraph = document.createElement("p")

      resultDiv.classList.add("linkbtn", "result-link")
      resultDiv.setAttribute("data-country", country.isoCode)
      resultDiv.setAttribute("data-market", country.market?.handle || "")
      resultDiv.setAttribute("data-language-raw", convertIsoCode(language.isoCode))

      countryParagraph.textContent = `${country.name} (${country.currency.isoCode} ${country.currency.symbol})`
      languageParagraph.textContent = language.name
      languageParagraph.classList.add("lang")

      resultDiv.appendChild(countryParagraph)
      resultDiv.appendChild(languageParagraph)
      searchHistoryDiv.appendChild(resultDiv)
    })
  })
}

function shx(countries) {
  const selectElementx = document.getElementById("shx")
  if (!selectElementx) return

  selectElementx.innerHTML = ""
  ;(countries || []).forEach((country) => {
    const option = document.createElement("option")
    option.value = country.isoCode
    option.setAttribute("data-lang", JSON.stringify(country.availableLanguages))
    option.setAttribute("data-handle", country.market?.handle || "")
    option.setAttribute("data-iso", country.isoCode)
    option.setAttribute("data-crc", country.currency?.isoCode || "")
    option.textContent = country.name
    selectElementx.appendChild(option)
  })
}

document.addEventListener("DOMContentLoaded", () => {
  startCurrencyBtnHideObserver()
  hideCurrencyBtnUntilFinalLoad()

  const hasUrlLocalePrefixOnLoad =
    !isShopifySystemPath(window.location.pathname) && !!getUrlLocalePrefix()

  if (hasUrlLocalePrefixOnLoad) {
    const urlPrefix = getUrlLocalePrefix()
    const { lang, country } = parsePrefixToCountryAndLang(urlPrefix)

    const currentCountry = normalizeCountryCode(document.getElementById("country_code")?.value || country || "")
    const currentLang = normalizeLocaleForShopify(
      document.getElementById("language_code")?.value || document.documentElement.lang || lang || "en"
    )

    if (currentCountry) {
      setSelectionCookie(currentCountry, currentLang)
      syncCurrencyFlagToCurrentState()
    }

    if (country && (currentCountry !== country || currentLang !== lang)) {
      console.log("URL locale prefix exists. Skip forced localization submit.", {
        urlPrefix,
        country,
        lang,
        currentCountry,
        currentLang,
      })
    }
  }

  const popupCrcValue = crcGetCookie("popupCrc")
  if (!hasUrlLocalePrefixOnLoad && popupCrcValue) {
    const didSubmit = handleLocalizationSubmission("popupCrc")
    if (didSubmit) return
  } else if (!hasUrlLocalePrefixOnLoad) {
    const last = crcLoadLastSelection()
    if (last?.country_code) {
      const currentCountry = normalizeCountryCode(document.getElementById("country_code")?.value || "")
      const currentLang = normalizeLocaleForShopify(
        document.getElementById("language_code")?.value || document.documentElement.lang || "en"
      )

      setSelectionCookie(last.country_code, last.language_code)

      if (currentCountry !== last.country_code || currentLang !== last.language_code) {
        try {
          sessionStorage.setItem(CRC_CURRENCY_HIDE_KEY, "1")
        } catch (e) {}
        setCurrencyBtnReadyState(false)

        submitToLocalization(last.country_code, last.language_code)
        return
      }
    }
  }

  const crcPopupBg = document.querySelector(".crc-popup-bg")
  if (crcPopupBg) crcPopupBg.classList.remove("init")

  const crcPopupSaveButton = document.querySelector(".save-btn")
  const localizationFormPopup = document.getElementById("localization_form")
  const crcPopupCancelButton = document.querySelector(".cancel-btn")
  const crcPopupClsButton = document.getElementById("crc-popup-close")

  const countryCodeEl = document.getElementById("country_code")
  const languageCodeEl = document.getElementById("language_code")

  const countryCode = countryCodeEl ? countryCodeEl.value : ""
  const languageCode = languageCodeEl ? languageCodeEl.value : ""

  if (crcPopupSaveButton && crcPopupBg && localizationFormPopup) {
    crcPopupSaveButton.addEventListener("click", (event) => {
      event.preventDefault()
      crcPopupBg.classList.remove("init")

      const selectedPopupCountryValue = document.getElementById("popup-country-select")?.value || countryCode
      const selectedPopupLanguageValue = document.getElementById("popup-lang-select")?.value || languageCode

      setSelectionCookie(selectedPopupCountryValue, selectedPopupLanguageValue)
      submitToLocalization(selectedPopupCountryValue, selectedPopupLanguageValue)
    })
  }

  if (crcPopupCancelButton && crcPopupBg) {
    crcPopupCancelButton.addEventListener("click", () => {
      setSelectionCookie(countryCode, languageCode)
      syncCurrencyFlagToCurrentState()
      crcPopupBg.classList.remove("init")
    })
  }

  if (crcPopupClsButton && crcPopupBg) {
    crcPopupClsButton.addEventListener("click", () => {
      setSelectionCookie(countryCode, languageCode)
      syncCurrencyFlagToCurrentState()
      crcPopupBg.classList.remove("init")
    })
  }

  document.addEventListener("click", (e) => {
    const currencyWrap = document.querySelector(".currency-wrap")

    const openBtn = e.target.closest(".currency-btn")
    if (openBtn) {
      e.preventDefault()
      currencyWrap?.classList.add("active")
      return
    }

    const closeBtn = e.target.closest("#currency-box-close")
    if (closeBtn) {
      e.preventDefault()
      currencyWrap?.classList.remove("active")
      return
    }

    if (e.target.classList && e.target.classList.contains("currency-wrap")) {
      currencyWrap?.classList.remove("active")
      return
    }
  })

  const searchInput = document.getElementById("regionSearch")
  const searchHistoryDiv = document.querySelector(".search-history")
  const countryCodeInput = document.getElementById("country_code")
  const languageCodeInput = document.getElementById("language_code")
  const languageSelect = document.getElementById("lang-select")

  if (languageSelect && localizationFormPopup) {
    languageSelect.addEventListener("change", () => {
      const selectedLanguageRaw = languageSelect.value
      const fixCountryValue = document.getElementById("country_code")?.value || ""
      setSelectionCookie(fixCountryValue, selectedLanguageRaw)
      submitToLocalization(fixCountryValue, selectedLanguageRaw)
    })
  }

  if (searchInput && searchHistoryDiv && localizationFormPopup) {
    searchInput.addEventListener("input", function () {
      const query = searchInput.value.toLowerCase().trim()
      searchHistoryDiv.innerHTML = ""

      if (query === "") {
        renderAllCountriesUI(availableCountries)
        return
      }

      const filteredResults = (availableCountries || []).reduce((acc, country) => {
        const countryMatch = String(country?.name || "").toLowerCase().includes(query)
        const langs = Array.isArray(country?.availableLanguages) ? country.availableLanguages : []
        const languageMatches = langs.filter((language) =>
          String(language?.name || "").toLowerCase().includes(query)
        )

        if (countryMatch || languageMatches.length > 0) {
          acc.push({
            ...country,
            availableLanguages: countryMatch ? langs : languageMatches,
          })
        }
        return acc
      }, [])

      filteredResults.forEach((country) => {
        ;(country.availableLanguages || []).forEach((language) => {
          const resultDiv = document.createElement("div")
          const countryParagraph = document.createElement("p")
          const languageParagraph = document.createElement("p")

          resultDiv.classList.add("linkbtn", "result-link")
          resultDiv.setAttribute("data-country", country.isoCode)
          resultDiv.setAttribute("data-language-raw", convertIsoCode(language.isoCode))
          resultDiv.setAttribute("data-market", country.market?.handle || "")

          countryParagraph.textContent = `${country.name} (${country.currency.isoCode} ${country.currency.symbol})`
          languageParagraph.textContent = language.name
          languageParagraph.classList.add("lang")

          resultDiv.appendChild(countryParagraph)
          resultDiv.appendChild(languageParagraph)
          searchHistoryDiv.appendChild(resultDiv)
        })
      })
    })

    searchHistoryDiv.addEventListener("click", (event) => {
      const clickedDiv = event.target.closest(".result-link")
      if (!clickedDiv) return

      const selectedCountry = clickedDiv.getAttribute("data-country")
      const selectedLanguageRaw = clickedDiv.getAttribute("data-language-raw")

      const c = normalizeCountryCode(selectedCountry || "US")
      const l = normalizeLocaleForShopify(selectedLanguageRaw || "en")

      if (countryCodeInput) countryCodeInput.value = c
      if (languageCodeInput) languageCodeInput.value = l

      setSelectionCookie(c, l)
      submitToLocalization(c, l)
    })
  }

  popupInitSetup()
  crcCallback()
})